import React, { useState } from 'react';

import { useRecoilState } from 'recoil';

import { useAdminUsersList } from 'lib/hooks/queries/admin/useAdminList';

import AddEditAdminModal from 'components/admin/components/AddEditAdminModal';
import AgTablePage from 'components/shared/AgTablePage/AgTablePage';
import Allowed from 'components/shared/Permissions/Allowed';
import state from 'components/state';

import AdminActions from './components/AdminActions';
import ButtonActions from './lib/ButtonActions';
import HeaderActions from './lib/HeaderActions';
import { defaultColumns, defaultFilters } from './lib/helper';

export default function AdminUsersTable() {
  const [permissions] = useRecoilState(state.permissions);
  const [editAdminData, setAdminData] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleEditAdmin = (data) => {
    setAdminData({
      ...data,
      role: {
        label: data.role,
        value: data.role_id
      }
    });
  };

  const closeAdminForm = () => {
    setAdminData(undefined);
    setIsModalOpen(false);
  };

  const onCellClicked = (e) => {
    if ((permissions && !permissions?.admin_users?.update) || e?.column?.colId === 'actions') {
      return;
    }
    if (e) {
      setAdminData({
        ...e,
        role: {
          label: e?.role,
          value: e?.role_id
        }
      });
    }
  };

  return (
    <Allowed requiredPermissions="admin_users.read" showIllustration showMessage>
      <AgTablePage
        keepOldFilters
        useData={useAdminUsersList}
        rightHeaderActions={<HeaderActions openModal={() => setIsModalOpen(true)} />}
        name="users"
        title="Admin Users"
        defaultFilters={defaultFilters}
        actions={ButtonActions}
        onSelectRow={(e) => onCellClicked(e)}
        defaultColumns={[
          ...defaultColumns,
          {
            field: 'actions',
            headerName: '',
            maxWidth: 100,
            minWidth: 100,
            resizable: false,
            cellRenderer: (params) => (
              <div className="flex h-full w-full items-center justify-center">
                <AdminActions
                  paramsData={params.data}
                  onHandleEdit={(data) => {
                    handleEditAdmin(data);
                  }}
                />
              </div>
            )
          }
        ]}
      />
      <AddEditAdminModal
        adminData={editAdminData}
        isModalOpen={!!editAdminData || isModalOpen}
        handleClose={closeAdminForm}
      />
    </Allowed>
  );
}
